import { Navigate } from 'react-router-dom';
import { canViewTimedLevelPage } from '../../components/layout/AppLayout';
import { useAuthStore } from '../../store/auth.store';
import TimedSettlementLevelsPanel from './TimedSettlementLevelsPanel';

export default function TimedSettlementLevelsPage() {
  const visiblePages = useAuthStore((state) => state.visiblePages);
  if (!visiblePages) return null;
  if (!canViewTimedLevelPage(visiblePages)) {
    return <Navigate to={visiblePages[0] ?? '/'} replace />;
  }
  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto">
      <TimedSettlementLevelsPanel />
    </div>
  );
}
